/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.reports.generator`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/reports/generator/generator.service.ts
 *
 * Internal sub-service of ReportsService; reached via inject() in Angular 18
 * and NOT downgrade-registered. Wave 3 item #16.
 */
angular.module('acme.common.service.reports.generator', [
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.calendar',
]);
